var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImpermeabilidad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6C6C6C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.1,122.2c-13.7,0-27.4-7.1-36.6-19.3C32,73.5,85.6,5.3,88,2.4L89.8,0l1.7,2.4c2.1,2.9,51.4,71.5,34.6,99 c-7.6,12.5-19.3,19.8-32.7,20.7C92.6,122.1,91.9,122.2,91.1,122.2z M89.6,7.9c-8.4,11.2-16.1,23-22.8,35.4 c-9.7,18.4-19.1,43.1-8.8,56.6C67,111.5,80,118,93,117.2c12-0.7,22.3-7.2,29.1-18.4c6.1-10,2.2-29.3-11.3-55.6 C104.5,31,97.4,19.2,89.6,7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.2,108.8c-16.3,0-23.6-18.4-25.2-28.6c-0.2-1.3,0.6-2.5,1.9-2.8c1.3-0.2,2.4,0.6,2.7,2 c0.9,4.7,2.4,9.2,4.7,13.5c4.5,8.2,10.7,11.9,18.1,11c1.3-0.2,2.4,0.9,2.5,2.2c0.1,1.3-0.8,2.4-2,2.6C88,108.7,87,108.8,86.2,108.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.1,158.3L0,110l40.2-26.3c1.1-0.6,2.5-0.2,3.2,1c0.6,1,0.2,2.4-0.7,3.1L9.2,109.6l76,43.2l84.6-45.4 l-37.3-19.6c-1.1-0.7-1.4-2.1-0.8-3.3c0.6-1,1.8-1.4,2.8-1l45.5,23.8L85.1,158.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.1,180L0,131.7l20.4-13.3c1.1-0.7,2.5-0.4,3.2,0.8c0.7,1.1,0.3,2.6-0.7,3.3l-13.7,9l76,43.2l84.6-45.4 l-15.3-8c-1.1-0.6-1.6-2.1-1-3.2c0.6-1.2,2-1.7,3.1-1.1l0,0l23.4,12.3L85.1,180z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.8,54.5c-1.3,0-2.3-1.1-2.3-2.4V35.2c0.2-1.3,1.4-2.2,2.7-2c0.9,0.2,1.7,0.9,1.9,2v16.9 C39.1,53.4,38,54.4,36.8,54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138,68.9c-1.3,0-2.3-1.1-2.3-2.4l0,0V47.2c-0.2-1.3,0.8-2.5,2.1-2.7c1.3-0.2,2.4,0.8,2.5,2.1 c0,0.2,0,0.4,0,0.6v19.3C140.3,67.8,139.3,68.9,138,68.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpermeabilidad);
export default __webpack_public_path__ + "static/media/impermeabilidad.d7b692dbbbbb5236c3e3fc9c3c432186.svg";
export { ForwardRef as ReactComponent };